import React, { FC } from 'react';
import { View } from 'react-native';

import { DebugMainMenuItems } from './components/DebugMainMenuItems';
import { DebugItems } from './DebugItems';
import { DebugMenuIDs } from './DebugMenuIDs';
import { styles } from './styles';

import { TWCPage } from '../primitives/TWCPage/TWCPage';
import { TWCText } from '../primitives/TWCText/TWCText';

export const DebugMainMenuPage: FC = () => (
  <TWCPage childIds={DebugItems.map(item => item.id)} firstFocus={DebugItems[0].id} pageID={DebugMenuIDs.debugMenuPage}>
    <View style={styles.pageTitleWrapper}>
      <TWCText noTestID variant={'regularText30'}>
        {'Debug Menu'}
      </TWCText>
    </View>
    <DebugMainMenuItems items={DebugItems} />
  </TWCPage>
);
